import { render, staticRenderFns } from "./organization_section.vue?vue&type=template&id=5bd3ae35&"
import script from "./organization_section.vue?vue&type=script&lang=js&"
export * from "./organization_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports